module.exports = __webpack_public_path__ + "img/EDU_staff_PP.b4c38d9c.jpg";